import { combineReducers } from 'redux';

import invoicesReducer from './ducks/invoices/reducers';

const reducers = {
  invoices: invoicesReducer,
};

export default combineReducers(reducers);
